import React, { useState, useEffect } from 'react';

import ButtonsBlock from '../share/ButtonsBlock'
import MultiSelectAnswer from '../share/MultiSelectAnswer';

import { MultiSelectQuestionStepProps } from '../../../types/components/user-survey/steps/MultiSelectQuestionStep';
import { AnswerConfig } from '../../../types/components/user-survey/shared/Answer';
import { getAnswersForMultiSelectStep } from '../helpers';

export const containerStyles = "flex flex-col items-center w-full"
export const questionStyles = "mb-4 text-center lg:mb-6 text-[21px] font-medium text-white"
export const subQuestionStyles = "mb-4 font-light text-gray-300"

export const mainContainerStyles = "relative w-full mb-10"
export const topFadeGradient = "absolute top-[-4px] left-0 right-0 z-10 h-4 pointer-events-none bg-gradient-to-b from-gray-900 to-transparent"
export const bottomFadeGradient = "absolute bottom-[-14px] left-0 right-2 h-6 bg-gradient-to-t from-gray-900 to-transparent z-10 pointer-events-none"

const MultiSelectQuestionStep: React.FC<MultiSelectQuestionStepProps> = ({
  question,
  stepIndex,
  onAnswersSelected,
  onBack,
  onNext,
  currentAnswers
}) => {
  const [selectedAnswers, setSelectedAnswers] = useState<AnswerConfig[]>(currentAnswers || []);

  useEffect(() => {
    if (currentAnswers) {
      setSelectedAnswers(currentAnswers);
    } else {
      setSelectedAnswers([]);
    }
  }, [currentAnswers, stepIndex]);


  const answers = getAnswersForMultiSelectStep();

  const handleNext = () => {
    onAnswersSelected(selectedAnswers);
    onNext();
  };

  return (
    <div cy-test-id="multi-select" className={containerStyles}>
      <h2 className={questionStyles}>{question}</h2>
      <p className={subQuestionStyles}>Select all that apply</p>


      <div className={mainContainerStyles}>

        <div className={topFadeGradient}></div>

        {/* Scrollable container with both columns */}
        <div className="flex w-full gap-2 max-h-[400px] scrollable-div overflow-y-auto pt-2 pb-6 pr-2">
          {/* Left column */}
          <div className="w-full space-y-3">
            {answers.slice(0, 7).map((answer) => (
              <MultiSelectAnswer
                key={answer.answerId}
                answer={{
                  ...answer,
                  stepIndexAfterAnswering: stepIndex + 1,
                }}
                selectedAnswers={selectedAnswers}
                setSelectedAnswers={setSelectedAnswers}
              />
            ))}
          </div>

          {/* Right column */}
          <div className="w-full space-y-3">
            {answers.slice(7, 15).map((answer) => (
              <MultiSelectAnswer
                key={answer.answerId}
                answer={{
                  ...answer,
                  stepIndexAfterAnswering: stepIndex + 1,
                }}
                selectedAnswers={selectedAnswers}
                setSelectedAnswers={setSelectedAnswers}
              />
            ))}
          </div>
        </div>

        <div className={bottomFadeGradient}></div>
      </div>

      <ButtonsBlock
        onNext={handleNext}
        nextDisabled={selectedAnswers.length === 0}
        onBack={onBack}
      />
    </div>
  );
};

export default MultiSelectQuestionStep;